import apiClient, { setAuthToken } from "./client";

export const login = async (credentials) => {
  const response = await apiClient.post("/api/auth/login", credentials);
  return response.data;
};

export { setAuthToken };
